"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var TableActionConfirm_1 = require("../../../../../../shared/components/table_actions/TableActionConfirm");
var TableActionReject_1 = require("../../../../../../shared/components/table_actions/TableActionReject");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var FinanceReconciliationsList = /** @class */ (function (_super) {
    __extends(FinanceReconciliationsList, _super);
    function FinanceReconciliationsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 200,
            }, {
                title: 'П.Программа',
                dataIndex: _this.props.data.dk_pprogram_title,
                key: _this.props.data.dk_pprogram_title,
                width: 200,
            }, {
                title: 'Сброс негативного баланса',
                dataIndex: _this.props.data.dk_is_reset_negative_balances,
                key: _this.props.data.dk_is_reset_negative_balances,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_reset_negative_balances, "ДА", "НЕТ")));
                },
                width: 200,
            }, {
                title: 'Кол-во партнеров',
                dataIndex: _this.props.data.dk_partners_count_inside,
                key: _this.props.data.dk_partners_count_inside,
                width: 200,
            }, {
                title: 'Выплата по игрокам',
                dataIndex: _this.props.data.dk_total_amount_by_players,
                key: _this.props.data.dk_total_amount_by_players,
                width: 200,
            }, {
                title: 'Выплата по субагентам',
                dataIndex: _this.props.data.dk_total_amount_by_subagents,
                key: _this.props.data.dk_total_amount_by_subagents,
                width: 200,
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Дата',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null, _this.getActionButtons(record))); },
                width: 110
            }
        ];
        return _this;
    }
    FinanceReconciliationsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    FinanceReconciliationsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceReconciliationsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceReconciliationsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    FinanceReconciliationsList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeDataByBrandsList({
            brands: this.props.BrandsList,
            allBrands: this.props.allBrands,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceReconciliationsList.prototype.onEditClick = function (record) {
        if (this.props.onEditReconciliation) {
            this.props.onEditReconciliation(record);
        }
    };
    FinanceReconciliationsList.prototype.onDetailsClick = function (record) {
        if (this.props.onDetailsReconciliation) {
            this.props.onDetailsReconciliation(record);
        }
    };
    FinanceReconciliationsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0421\u0432\u0435\u0440\u043A\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    FinanceReconciliationsList.prototype.onFillPartnersClick = function (record) {
        var _this = this;
        this.props.data.DoFillPartners(record.key, function (added) {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B \u0432 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435 ",
                    React.createElement("b", null,
                        "[",
                        added,
                        "]"),
                    " \u0431\u044B\u043B\u0438 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u0441\u0432\u0435\u0440\u043A\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.title,
                        "]")));
            });
        });
    };
    FinanceReconciliationsList.prototype.onClearPartnersClick = function (record) {
        var _this = this;
        this.props.data.DoClearPartners(record.key, function (affected) {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u044B \u0432 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435 ",
                    React.createElement("b", null,
                        "[",
                        affected,
                        "]"),
                    " \u0431\u044B\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u0441\u0432\u0435\u0440\u043A\u0438",
                    React.createElement("b", null,
                        "[",
                        record.title,
                        "]")));
            });
        });
    };
    FinanceReconciliationsList.prototype.getActionButtons = function (record) {
        var _this = this;
        var _ret = [];
        // if (record.is_pending) {
        _ret.push(React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); }, key: "ab_1" }));
        _ret.push(React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onDetailsClick(record); }, key: "ab_2" }));
        _ret.push(React.createElement(TableActionConfirm_1.default, { hint: "\u0418\u043C\u043F\u043E\u0440\u0442 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432", confirmText: "\u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432 ?", onClick: function () { _this.onFillPartnersClick(record); }, key: "ab_3" }));
        _ret.push(React.createElement(TableActionReject_1.default, { hint: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432", confirmText: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432 ?", onClick: function () { _this.onClearPartnersClick(record); }, key: "ab_4" }));
        _ret.push(React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0432\u0435\u0440\u043A\u0443 ?", onClick: function () { _this.onDeleteClick(record); }, key: "ab_5" }));
        //} else {
        //    _ret.push(<TableActionLockLock disabled confirmText="Подтвердить выплату ?" onClick={() => { }} key={"al_1"} />);
        //    _ret.push(<TableActionLockLock disabled confirmText="Отменить выплату ?" onClick={() => { }} key={"al_2"} />);
        //}
        return _ret;
    };
    FinanceReconciliationsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props);
        });
    };
    FinanceReconciliationsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action == "create") {
            if (this.props.onNewReconciliation) {
                this.props.onNewReconciliation();
            }
        }
    };
    FinanceReconciliationsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FinanceReconciliationsList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    /*private doCalculateRevShares() {
        let _dtFrom = moment().startOf('month');
        let _dtTo = moment().add(0, 'd').set('hour', 0).set('minute', 0).set('second', 0);
        //
        this.props.dlgCalculateRevShare
            .SetDateFrom(_dtFrom)
            .SetDateTo(_dtTo)
            .SetTitle("Расчет revshare")
            .SetOnYesClick((dFrom, dTo, ignoreStart) => {

                this.props.data.DoGenerateRevshare({

                    pprograms: this.props.PProgramsList,
                    allPPrograms: this.props.allPPrograms,

                    from_year: dFrom.get('year'),
                    from_month: dFrom.get('month') + 1,
                    from_day: dFrom.get('date'),

                    to_year: dTo.get('year'),
                    to_month: dTo.get('month') + 1,
                    to_day: dTo.get('date'),

                    is_ignore_start_date: ignoreStart

                }, (generatedCount) => {
                    notificationHelper.ShowTopRightNotification(<div>Расчет вознаграждений окончен! Сгенерировано [{generatedCount}] вознаграждений</div>);
                    if (generatedCount > 0) {
                        this.loadData(this.props);
                    }
                });

            })
            .Show();
    }*/
    FinanceReconciliationsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.BrandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                            " [",
                            record.description,
                            "]")));
                }, scroll: { x: true } })));
    };
    return FinanceReconciliationsList;
}(React.Component));
exports.default = FinanceReconciliationsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/component/FinanceReconciliationsList.tsx
// module id = 2554
// module chunks = 0